export default class ReadingProgress {
  constructor() {
    this.progressBar = document.querySelector('.js-reading-progressbar')
    this.scrollHeight = 0
    this.viewportHeight = 0
    this.maxScrollDistance = 0
  }

  init() {
    if (!this.progressBar) return

    // Calculate dimensions
    this.calculateDimensions()

    // Update progress on scroll
    window.addEventListener('scroll', this.updateProgress.bind(this))

    // Recalculate dimensions on resize
    window.addEventListener('resize', this.calculateDimensions.bind(this))
  }

  calculateDimensions() {
    this.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    this.viewportHeight = window.innerHeight
    this.maxScrollDistance = this.scrollHeight - this.viewportHeight
  }

  updateProgress() {
    if (this.maxScrollDistance <= 0) return

    const scrollPosition = window.scrollY
    const scrollPercentage = (Math.round((scrollPosition / this.maxScrollDistance) * 10000) / 100)

    // Update the progress bar value
    this.progressBar.value = Math.min(scrollPercentage, 100)
  }
}
